/**
 * Created by Mike Naughton on 2/15/18.
 */

import s from "underscore.string";
import ModalView from "core/views/ModalView";
import _ from "underscore";

/**
 * Normalizes button options.
 * @param  {String} title   The title of the modal for which the button will be used.
 * @param  {String|Object} button  Button text or an object specifying button options.
 * @param  {Function} action  An action to execute when the button is clicked.
 * @param  {Object} [options] Any additional options to combine into the result.
 * @return {Object}         An object specifying all button options.
 */
function normalizeButton(title, button, action, options) {
  if (!_.isFunction(action)) {
    action = function () {};
  }

  var opts = _.defaults({}, options, {
    text: button,
    click: action,
    type: "default",
  });

  if (_.isObject(button)) {
    opts = button;

    if (!_.isUndefined(options)) {
      if (!_.isUndefined(options.type)) {
        opts.type = options.type;
      }
    }
    var oldClick = opts.click;

    opts.click = function () {
      if (_.isFunction(oldClick)) {
        oldClick();
      }

      action();
    };
  }

  opts.className = opts.className || "";
  opts.className += " " + s.slugify(title + " " + opts.text);

  return opts;
}

function createLoadView() {
  var $el = $(".app-loading");
  var modalTitle;
  var loadView;

  if ($el.length <= 0) {
    $el = null;
  } else {
    $el = $el.parent();
    modalTitle = $el.find(".modal-title").html();
  }

  loadView = new ModalView({
    title: modalTitle,
    locked: true,
    modalClass: "app-loading",
    el: $el,
    removeWhenHidden: false,
  });

  loadView.render();
  loadView.show();
  loadView.inProgress(true);

  if (!$el) {
    loadView.hide();
  }

  return loadView;
}

export default {
  /**
   * Presents a modal alert dialog.
   * @param  {string}   title   The alert title.
   * @param  content The content to place in the dialog.
   * @param  {string|object}   button  The dismissal button text or options to be passed to the ButtonView constructor.
   * @param  {Function} [next]    A function to execute after the dialog has been dismissed.
   * @param  {boolean} locked   A parameter Prevent Bootstrap Modal from disappearing when clicking outside or pressing escape
   * @param  {boolean} remove   A parameter indicating if the modal should be removed when the button is clicked
   * @return {ModalView}           The view that was presented.
   */
  alert: function (title, content, button, next, locked, remove) {
    if (!_.isFunction(next)) {
      next = function () {};
    }

    if (_.isUndefined(remove)) {
      remove = true;
    }

    var modalView = new ModalView({
      locked: locked,
      title: title,
      modalClass: s.slugify(title),
      buttons: [
        normalizeButton(title, button, function () {
          if (remove) {
            modalView.hide(); //modal is removed after hiding
          }

          next(modalView);
        }),
      ],
    });

    modalView.render();
    modalView.setContent(content);
    modalView.show();

    return modalView;
  },

  /**
   * Presents a modal confirmation dialog.
   * @param  {string}   title   The alert title.
   * @param  content The content to place in the dialog.
   * @param  {string|object}   confirmButton  The confirmation button text or options to be passed to the ButtonView constructor.
   * @param  {Function} [confirmAction]    A function to execute when the confirm button has been pressed.
   * @param  {string|object}   [cancelButton='Cancel']  The cancel button text or options to be passed to the ButtonView constructor.
   * @param  {Function} [cancelAction]    A function to execute when the cancel button has been pressed.
   * @param  {String} [modalClass] A string specifying an additional class for the modal container.
   * @return {ModalView}           The view that was presented.
   */
  confirm: function (
    title,
    content,
    confirmButton,
    confirmAction,
    cancelButton,
    cancelAction,
    modalClass
  ) {
    if (!_.isFunction(confirmAction)) {
      confirmAction = function () {};
    }

    if (!_.isFunction(cancelAction)) {
      cancelAction = function () {};
    }

    var _confirmAction = function () {
      confirmAction();

      modalView.hide(); //modal is removed after hiding
    };
    var _cancelAction = function () {
      cancelAction();

      modalView.hide(); //modal is removed after hiding
    };
    var options = {
      type: "primary",
    };
    var modalView = new ModalView({
      title: title,
      modalClass: modalClass || s.slugify(title),
      buttons: [
        normalizeButton(title, cancelButton || "Cancel", _cancelAction),
        normalizeButton(title, confirmButton, _confirmAction, options),
      ],
    });

    modalView.render();
    modalView.setContent(content);
    modalView.show();

    return modalView;
  },

  /**
   * Presents a modal dialog.
   * @param  {string}   title   The alert title.
   * @param  content The content to place in the dialog.
   * @param {Boolean} locked:false True to prevent the user from closing the dialog, otherwise false.
   * @return {ModalView}           The view that was presented.
   */
  modal: function (title, content, locked) {
    var modalView = new ModalView({
      title: title,
      locked: locked,
      modalClass: s.slugify(title),
    });

    modalView.render();
    modalView.setContent(content);
    modalView.show();

    return modalView;
  },

  loading: createLoadView(),
};



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/modals.js
// module id = 46
// module chunks = 1